import axios, { clientRecords, extractData, extractError, invoicingEntityApi } from '@atheneum/api'
import { action, computed, extendObservable } from 'mobx'

class InvoicingStore {
  constructor (staticData, growlStore) {
    extendObservable(this, {
      loading: false,
      error: null,
      loadingSingleEntity: false,
      loadingInvoicingRegion: false,
      invoicingEntities: [],
      invoicingEntitiesCount: null,
      staticData,
      growlStore,
      parentAccountId: null,
      singleEntity: null,
      phoneNumbers: computed(() => {
        if (!this.singleEntity) return ''
        const phones = this.singleEntity.address.phones.map(number => {
          const phoneType = this.staticData.names.phoneTypes[number.phoneTypeId]
          return { ...number, phoneType }
        })
        return phones
      }),
      timezone: computed(() => {
        if (!this.singleEntity) return ''
        const timezoneId = this.singleEntity.address.timezoneId
        return this.staticData.names.timezones[timezoneId]
      }),
      invoicingRegion: null,
      query: this.defaultSearchQuery()
    })
  }

  defaultSearchQuery () {
    return {
      parentAccountId: null,
      legalName: '',
      glCode: '',
      country: ''
    }
  }

  clearSearch (parentAccountId) {
    this.query = this.defaultSearchQuery()
    this.query.parentAccountId = parentAccountId
  }

  loadInvoicingEntities (parentAccountId) {
    this.loading = true
    this.query = this.defaultSearchQuery()
    this.parentAccountId = parentAccountId
    this.query.parentAccountId = parentAccountId
    clientRecords
      .getInvoicingEntities(parentAccountId)
      .then(res => {
        const formattedInvoices = res.rows.map(invoice => {
          const countryId = invoice.address.countryId
          const country = this.staticData.names.countries[countryId]
          return { ...invoice, country }
        })
        this.invoicingEntities = formattedInvoices
        this.invoicingEntitiesCount = res.count
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  filter () {
    this.loading = true
    invoicingEntityApi
      .search(this.query)
      .then(res => {
        const formattedInvoices = res.rows.map(invoice => {
          const countryId = invoice.address.countryId
          const country = this.staticData.names.countries[countryId]
          return { ...invoice, country }
        })
        this.invoicingEntities.replace(formattedInvoices)
        this.invoicingEntitiesCount = res.count
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  deleteInvoicingEntity = action(invoiceId => {
    return invoicingEntityApi
      .deleteInvoicingEntity(invoiceId)
      .then(() => {
        const afterDelete = this.invoicingEntities.filter(
          entity => entity.id !== invoiceId
        )
        this.invoicingEntities.replace(afterDelete)
      })
      .catch(err => {
        this.error = extractError(err)
        this.growlStore.addNotification({
          title: 'Error!',
          message: this.error.message,
          type: 'error',
          autoClose: true
        })

        throw err
      })
  })

  getInvoicingEntityId = action(invoicingEntityId => {
    this.loadingSingleEntity = true
    return axios
      .get('/api/invoicing-entity/' + invoicingEntityId)
      .then(res => {
        const responseData = extractData(res)
        this.singleEntity = responseData
      })
      .then(() => {
        this.loadingSingleEntity = false
      })
  })

  getInvoicingRegion = action(invoicingRegionId => {
    this.loadingInvoicingRegion = true
    return axios
      .get('/api/invoicing-region/' + invoicingRegionId)
      .then(res => {
        const responseData = extractData(res)
        this.invoicingRegion = responseData
      })
      .then(() => {
        this.loadingInvoicingRegion = false
      })
  })
}

export default InvoicingStore
